import React from 'react'
import { Helmet } from 'react-helmet'
import { makeStyles } from '@material-ui/core/styles'
import { useStaticQuery, graphql } from 'gatsby'
import Box from '@material-ui/core/Box'
import Header from './header'
import "normalize.css"

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#004165',
    paddingBottom: 64,
    minHeight: '100vh',
  },
}))

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  const classes = useStyles()

  return (
    <Box className={ classes.root }>
      <Helmet>
        <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap" rel="stylesheet" />
      </Helmet>
      <Header siteTitle={data.site.siteMetadata.title} />
        <main>{children}</main>
    </Box>
  )
}

export default Layout
